import { memo } from "react";
import { UserBase } from "../types";
import "./user-select-option.scss";

const UserSelectOption = memo(({ value }: { value: UserBase }) => (
  // className контейнера находится выше (options className)
  <>
    <span className="user-select-option-title">
      {[value.userSurname, value.userFirstName, value.userMiddleName]
        .filter(Boolean)
        .join(" ")}
    </span>
    <br />
    <span className="user-select-option-subtitle">{value.userEmail}</span>
  </>
));

export default UserSelectOption;
